import { ThemeProvider } from '@wp-g2/styles';
import React from 'react';
import { Portal as BasePortal } from 'reakit';

function Portal(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(BasePortal, null, /*#__PURE__*/React.createElement(ThemeProvider, null, children));
}

export default Portal;